import startEn from "assets/level-recommendation/start.png";
import startVi from "assets/level-recommendation/start-vi.png";
import startDe from "assets/level-recommendation/start-de.png";
import startIt from "assets/level-recommendation/start-it.png";
import startFr from "assets/level-recommendation/start-fr.png";
import startJp from "assets/level-recommendation/start-jp.png";
import stayEn from "assets/level-recommendation/stay.png";
import stayVi from "assets/level-recommendation/stay-vi.png";
import stayDe from "assets/level-recommendation/stay-de.png";
import stayIt from "assets/level-recommendation/stay-it.png";
import stayFr from "assets/level-recommendation/stay-fr.png";
import stayJp from "assets/level-recommendation/stay-jp.png";
import moveUpEn from "assets/level-recommendation/move-up.png";
import moveUpVi from "assets/level-recommendation/move-up-vi.png";
import moveUpDe from "assets/level-recommendation/move-up-de.png";
import moveUpIt from "assets/level-recommendation/move-up-it.png";
import moveUpFr from "assets/level-recommendation/move-up-fr.png";
import moveUpJp from "assets/level-recommendation/move-up-jp.png";
import moveDownEn from "assets/level-recommendation/move-down.png";
import moveDownVi from "assets/level-recommendation/move-down-vi.png";
import moveDownDe from "assets/level-recommendation/move-down-de.png";
import moveDownIt from "assets/level-recommendation/move-down-it.png";
import moveDownFr from "assets/level-recommendation/move-down-fr.png";
import moveDownJp from "assets/level-recommendation/move-down-jp.png";

type Artwork = {
  start: string;
  stay: string;
  moveUp: string;
  moveDown: string;
};

const artwork: Record<string, Artwork> = {
  en: {
    start: startEn,
    stay: stayEn,
    moveUp: moveUpEn,
    moveDown: moveDownEn,
  },
  vi: {
    start: startVi,
    stay: stayVi,
    moveUp: moveUpVi,
    moveDown: moveDownVi,
  },
  de: {
    start: startDe,
    stay: stayDe,
    moveUp: moveUpDe,
    moveDown: moveDownDe,
  },
  it: {
    start: startIt,
    stay: stayIt,
    moveUp: moveUpIt,
    moveDown: moveDownIt,
  },
  fr: {
    start: startFr,
    stay: stayFr,
    moveUp: moveUpFr,
    moveDown: moveDownFr,
  },
  jp: {
    start: startJp,
    stay: stayJp,
    moveUp: moveUpJp,
    moveDown: moveDownJp,
  },
};

export default function recommendationArtwork(locale: string): Artwork {
  return artwork[locale.toLowerCase().split(/[-_]/)[0]] || artwork.en;
}
